var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusRectangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#2B55EF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.33333H7V11.3333H8.33333V9.33333H10.3333V8H8.33333V6H7V8H5V9.33333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 1.6H12.4444V0H10.6667V1.6H5.33333V0H3.55556V1.6H1.77778C0.797333 1.6 0 2.3176 0 3.2V14.4C0 15.2824 0.797333 16 1.77778 16H14.2222C15.2027 16 16 15.2824 16 14.4V3.2C16 2.3176 15.2027 1.6 14.2222 1.6ZM14.224 14.4H1.77778V4.8H14.2222L14.224 14.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRectangle);
export default __webpack_public_path__ + "static/media/plus_rectangle.fd422bdaa2307400e71163a5079acd0e.svg";
export { ForwardRef as ReactComponent };